import React from "react";
import type { JSX } from "react";

interface FormInputProps {
  name: string;
  type: string;
  placeholder: string;
  value: string;
  onChange: React.FormEventHandler<HTMLInputElement>;
  required?: boolean;
  maxLength?: number;
  typeClass?: string;
}

function FormInput({
  name,
  type,
  placeholder,
  value,
  onChange,
  required = false,
  maxLength = 80,
  typeClass = "",
}: FormInputProps) {
  return (
    <input
      name={name}
      className={`${typeClass} field-required w-[315px] h-10 font-['Poppins'] not-italic font-normal text-sm leading-[15px] border-none bg-white py-0 px-[15px] outline-none text-[#333333] placeholder-[#333333] lg:w-[230px]`}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required={required}
      maxLength={maxLength}
    />
  );
}

export default FormInput;

